import React, { useState } from "react";
import Widget from "../../components/Widget/Widget.js";
import Timeline from "./components/MonitoringComponents/Timeline.js";
import Table from "./components/MonitoringComponents/BatteryTable.js";
import PowerConsumptionChart from "./components/MonitoringComponents/PowerConsumptionChart.js";
import PowerConsumptionWidget from "./components/MonitoringComponents/PowerConsumptionWidget.js";
import styles from "./Monitoring.module.scss";
import { useSelector } from "react-redux";
import Select from "react-select";
import ErrorsTimeline from "./components/MonitoringComponents/ErrorsTimeline.js";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchBuildings } from "../../actions/building.js";

function Monitoring() {
  const store = useSelector((state) => state.auth);
  // Multi Select States
  const [assetValue, setAssetValue] = useState({
    value: 0,
    label: "Select Building",
    hasBattery: false,
    cc: 0,
  });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchBuildings());
  }, [dispatch]);

  const buildingStore = useSelector((state) => state.buildings);
  const buildingOptions = buildingStore.buildings
    .sort((a, b) => (a.facility_id === 0) - (b.facility_id === 0) || (a.facility_id - b.facility_id))
    .map((building) => {
      return {
        value: building.id,
        label: building.name,
        hasBattery: building.battery_table !== null,
        batteries: building.battery_table,
        cc: building.contract_cap ? parseFloat(building.contract_cap) : null,
      };
    });

  return (
    <div>
      <div className={styles.MonitoringAssetOptionContainer}>
        <Select
          defaultValue={assetValue}
          options={buildingOptions}
          onChange={setAssetValue}
          classNamePrefix="react-select"
          styles={{
            control: (base) => ({
              ...base,
              backgroundColor: 'var(--input-bg)',
              color: 'var(--body-color)',
              borderColor: 'var(--input-border)'
            }),
            singleValue: (base) => ({ ...base, color: 'var(--body-color)' }),
            menu: (base) => ({ ...base, backgroundColor: 'var(--card-bg)', color: 'var(--body-color)' }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isFocused ? 'var(--sidebar-hover-bg)' : 'transparent',
              color: 'var(--body-color)'
            })
          }}
        />
      </div>
      {assetValue.value > 0 && (
        <div className={styles.WidgetContainer}>
          <Widget title="Power Consumption">
            <PowerConsumptionChart 
              buildingId={assetValue.value} 
              contractCap={assetValue.cc}
              userRole={"admin"}  
            />
          </Widget>
        </div>
      )}
      {assetValue.hasBattery && (
        <div className={styles.WidgetContainer}>
          <Widget
            title="Power Consumption Table "
            className={styles.PowerConsumptionTableContainer}
          >
            <PowerConsumptionWidget
              assetValue={assetValue}
              // selectedBattery={selectedBattery}
              // setSelectedBattery={setSelectedBattery}
            />
          </Widget>
        </div>
      )}
      {/* {store?.currentUser?.role === "admin" && 
      assetValue.hasBattery && (
        <div className={styles.WidgetContainer}>
          <Widget title="Charge Settings">
            <ChargeSettings
              assetValue={assetValue}
              selectedBattery={selectedBattery}
              setSelectedBattery={setSelectedBattery}
            />
          </Widget>
        </div>
      )} */}

      {assetValue.hasBattery && (
        <div>
          <div className={styles.WidgetContainer}>
            <Widget title="Battery Data" className={styles.BatteryTableContainer}>
              <Table assetValue={assetValue} />
            </Widget>
          </div>
          <div className={styles.WidgetContainer}>
            <Widget title="Actions" className={styles.TimelineTableContainer}>
              <Timeline assetValue={assetValue} />
            </Widget>
          </div>
          <div className={styles.WidgetContainer}>
            <Widget title="Errors" className={styles.TimelineTableContainer}>
              <ErrorsTimeline assetValue={assetValue} />
            </Widget>
          </div>
        </div>
      )}
    </div>
  );
}

export default Monitoring;